import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import iconZeroDebt from './images/icon-zero-debt.svg';
import iconAssets from './images/icon-assets.svg';
import iconPassiveIncome from './images/icon-passive-income.svg';
import Interested from '../common/components/interested/Interested';
import { Helmet } from 'react-helmet';

function About() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Sera - About Us</title>
      </Helmet>
      <section className='about'>
        <section className='hero'>
          <div className='title'>About us</div>
        </section>
        <div className='title main'>What is Sera?</div>
        <p>
          Sera is a financial wellness platform founded by a group of experienced fintech startup execs 
          with a singular mission: to help individuals and families achieve sustainable financial freedom 
          as quickly and simply as possible. This sounds like a big feat, and it is, given two-thirds of 
          American families are struggling to pay off their debt, let alone build sustainable income and lasting wealth. 
        </p>
        <div className='financial-freedom'>
          <div className='steps-container'>
            <div className='title'>How do you achieve sustainable financial freedom?</div>
            <div className='steps'>
              <div className='step'>
                <img src={iconZeroDebt} alt='zero-debt' />
                <p>Achieve zero debt</p>
              </div>
              <div className='step'>
                <img src={iconAssets} alt='assets' />
                <p>Accumulate adequate assets</p>
              </div>
              <div className='step'>
                <img src={iconPassiveIncome} alt='passive-income' />
                <p>Attain optimal passive income</p>
              </div>
            </div>
          </div>
        </div>
        <br/>
        <div className='title'>How can Sera help you?</div>
        <p>
          Sera&apos;s foundational technology can help individuals and families unlock the power of their credit to pay down their debt faster and at less interest expense than any other traditional method. And once out of debt, Sera enables participants to grow their asset base and develop passive income streams that can help them retire early without the need of a traditional salary.
        </p>

        <div className='section'>
          <div className='title'>How do we do it?</div>
          <p>
            We do this by leveraging proven methods developed by <Link to='/phong-nguyen-founders-story'>Sera&apos;s Founder and Ceo, Phong Nguyen</Link>. After developing and using this method successfully, he retired in 2001 at the age of 42 - and in San Jose, CA with one of the highest costs of living in the nation. 
          </p>
          <p>
            Given his own experience achieving financial freedom, Phong wanted to help others and so began teaching his program of debt elimination and asset acceleration to students from a variety of ages and economic circumstances throughout the Bay Area.
          </p>
          <p>
            While the program proved successful for a large number of participants, there were definitely some challenges. The essential challenge was that almost all of the work of achieving zero-debt as quickly and inexpensively as possible was entirely manual. Participants found it challenging to manage their work, family and community obligations alongside optimizing their bill payments, interest rates, and spending habits. There was also the challenge of identifying and gaining access to reliable, high yield investment opportunities which required a lot of upfront research time as well as monitoring and management once those investments were made.
          </p>
        </div>
        <div style={{textAlign: 'center'}}>
          <img className='financial-freedom-img' alt='' />
        </div>
        <p>
          Phong and his students quickly realized that there was a significant opportunity to help a much larger number of people. So, he gathered a group of experienced startup and fintech leaders to help build toward his vision of a financial wellness platform that provides the simplicity, automation and AI necessary to scale his method to the masses. 
        </p>
        <p>
        Sign up for a Sera checking and optional savings account and link your credit card, investment and bill pay accounts in the Sera app. Our platform will automate your bill payments and manage your cashflow to save you the most time and money. We&apos;ll also find and recommend lower interest rate credit options to pay down your debt faster and cheaper, alongside reliable, high yield investments opportunities to help you develop sustaining passive income streams. Sera will provide personalized recommendations every step of the way along your financial journey. 
        </p>
        <p>
          This is Sera. <br/>
          Financial freedom. Simplified.
        </p>
      </section>
      <Interested showGraphic={false} />
    </React.Fragment>
  );
};

export default About;